const ERRORS = {
  undefinedParamsForCalc: 'undefinedParamsForCalc',
};
export default ERRORS;
